<template>
  <span class="addbtn" title="添加" v-on="$listeners">
    <i class="el-icon-plus"></i>
  </span>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.addbtn {
  padding: 4px 5px;
  margin-left: 5px;
  background: rgba(85, 132, 255, 0.07);
  border: 1px dashed rgba(56, 115, 254, 0.67);
  border-radius: 5px;
  cursor: pointer;
  user-select: none;
  i {
    color: var(--theme-color);
    font-size: 14px;
  }
}
</style>
